export default "__VITE_ASSET__894bf2d5__"